module.exports = __webpack_public_path__ + "images/emoji/lemon.6e32ab9e3bb4a05471b3.png";